"use strict";
// Copyright © 2021 Move Closer
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdBannerModuleUi = void 0;
const vue_property_decorator_1 = require("vue-property-decorator");
const ui_1 = require("../_abstract/ui");
const AdBanner_contracts_1 = require("./AdBanner.contracts");
const AdBannerGoogle_ui_1 = require("./versions/AdBannerGoogle.ui");
const AdBannerWTG_ui_1 = require("./versions/AdBannerWTG.ui");
const adBannerVersionUiComponentRegistry = {
    [AdBanner_contracts_1.AdBannerVersion.GoogleAds]: AdBannerGoogle_ui_1.AdBannerGoogle,
    [AdBanner_contracts_1.AdBannerVersion.WayToGrow]: AdBannerWTG_ui_1.AdBannerWTG
};
/**
 * Component capable of rendering the `AdBannerModule's` contents.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
let AdBannerModuleUi = class AdBannerModuleUi extends ui_1.AbstractModuleUi {
    get bannerComponent() {
        if (!(this.module.version in adBannerVersionUiComponentRegistry)) {
            this.onError(`AdBannerModule.[get]component(): There's no UI component for the given module version!\nFull [this.module] object: ${JSON.stringify(this.module)}`);
            return AdBannerGoogle_ui_1.AdBannerGoogle;
        }
        return adBannerVersionUiComponentRegistry[this.module.version];
    }
};
__decorate([
    vue_property_decorator_1.Prop({
        type: Function,
        required: false
    }),
    __metadata("design:type", Object)
], AdBannerModuleUi.prototype, "onEmptyCallback", void 0);
__decorate([
    vue_property_decorator_1.Prop({
        type: Boolean,
        required: false,
        default: false
    }),
    __metadata("design:type", Boolean)
], AdBannerModuleUi.prototype, "forceHide", void 0);
AdBannerModuleUi = __decorate([
    vue_property_decorator_1.Component({
        name: 'AdBannerModuleUi',
        components: { AdBannerGoogle: AdBannerGoogle_ui_1.AdBannerGoogle, AdBannerWTG: AdBannerWTG_ui_1.AdBannerWTG },
        template: `
    <component :is="bannerComponent" v-bind="$props" />
  `
    })
], AdBannerModuleUi);
exports.AdBannerModuleUi = AdBannerModuleUi;
//# sourceMappingURL=AdBanner.ui.js.map